import { withHandlers, withState, compose } from 'recompose';
import { fetchShopBarbers } from '../../../barbers/actions/shop';

const withBarbersByShop = compose(
  withState('barbersByShop', 'setBarbersByShop', {}),
  withState('isLoadingBarbersByShop', 'setIsLoadingBarbersByShop', {}),
  withHandlers({
    ensureShopBarbersLoaded: (props) => async (shopId) => {
      // If we already have the barbers, return them
      if (props.barbersByShop[shopId]) {
        return props.barbersByShop[shopId];
      }

      // for shop user we've already pre-loaded the barbers
      if (props.roleIdType.type === 'shop') {
        const barbers = props.shops.find((shop) => shop.id === shopId)?.barbers || [];
        props.setBarbersByShop({
          [shopId]: barbers,
        });
        return barbers;
      }

      // If we're already loading, return null to indicate in-progress
      if (props.isLoadingBarbersByShop[shopId]) {
        return null;
      }

      // Load the barbers
      props.setIsLoadingBarbersByShop({
        ...props.isLoadingBarbersByShop,
        [shopId]: true,
      });
      try {
        const barbers = await fetchShopBarbers(shopId);
        props.setBarbersByShop({
          ...props.barbersByShop,
          [shopId]: barbers,
        });
        return barbers;
      } catch (error) {
        props.addNotification?.({
          title: 'Failed to load barbers',
          level: 'error',
          message: 'There was an error loading the barbers. Please try again.',
        });
        return null;
      } finally {
        props.setIsLoadingBarbersByShop({
          ...props.isLoadingBarbersByShop,
          [shopId]: false,
        });
      }
    },
  })
);

export default withBarbersByShop;
